import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=5d34fe28&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=5d34fe28&prod&scoped=true&lang=css"
import style1 from "./recommend.vue?vue&type=style&index=1&id=5d34fe28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34fe28",
  null
  
)

export default component.exports